import React, { useState } from 'react';
import PropTypes from 'prop-types';

const IS_VALID = 'is-valid';
const IS_INVALID = 'is-invalid';
const HAS_SUCCESS = 'has-success';
const HAS_DANGER = 'has-danger';

const TextFormGroup = ({
  name,
  value,
  label,
  handleChange,
  handleBlur,
  valid,
  touched,
  invalidFeedback
}) => {

  return (
    <div
      className={
        `form-group${touched && valid ? ` ${HAS_SUCCESS}` : ''}${touched && !valid ? ` ${HAS_DANGER}` : ''}`
      }
    >
      <label className="form-control-label">{label}</label>
      <textarea
        name={name}
        value={value}
        className={
          `form-control${touched && valid ? ` ${IS_VALID}` : ''}${touched && !valid ? ` ${IS_INVALID}` : ''}`
        }
        rows="3" 
        spellCheck="true"
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
      />
      {touched && !valid && <div className="invalid-feedback">{invalidFeedback}</div>}
    </div>
  )
};

TextFormGroup.props = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  invalidFeedback: PropTypes.string,
  valid: PropTypes.bool,
  touched: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
};

TextFormGroup.defaultProps = {
  type: "text",
  invalidFeedback: 'Field is required',
  valid: false,
  touched: false,
  value: '',
}

export default TextFormGroup;
